;(function (angular) {
   'use strict'

   angular.module('app').factory('csvService', CsvService)

   function CsvService($q, $ocLazyLoad, $window) {
      var _isPapaParseLoaded = false

      // Note that this makes `Papa` available on the global window object.
      function loadPapaParse() {
         if (_isPapaParseLoaded) {
            return $q.resolve()
         }
         return $ocLazyLoad
            .load(['https://cdnjs.cloudflare.com/ajax/libs/PapaParse/5.4.1/papaparse.min.js'])
            .then(function () {
               _isPapaParseLoaded = true
            })
      }

      function createAndDownloadCsv(csvRows, fileName) {
         return loadPapaParse().then(function () {
            var csvContent = $window.Papa.unparse(csvRows, {
               delimiter: ',',
               newline: '\n',
               quotes: true,
               quoteChar: '"',
               escapeChar: '"',
            })

            // Add UTF-8 BOM for improved compatibility (though this is optional, it's needed for some apps like Excel)
            const bom = '\uFEFF'
            const csvWithBom = bom + csvContent

            // Create a Blob with the CSV content
            const blob = new Blob([csvWithBom], {type: 'text/csv;charset=utf-8'})

            // Create a URL for the Blob
            const url = $window.URL.createObjectURL(blob)

            // Create and trigger the download
            const link = document.createElement('a')
            link.setAttribute('href', url)
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()

            // Clean up
            document.body.removeChild(link)
            $window.URL.revokeObjectURL(url)
         })
      }

      // ====================================================================

      return {
         createAndDownloadCsv: createAndDownloadCsv,
      }
   }
})(angular)
